import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { StorageService } from '../../../services/commons/storage.service';
import { AuthService } from '../../../services/commons/auth.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { PasswordUpdateResponse } from '../../../services/SicorService/ResponseObject/PasswordUpdateResponse';

@Component({
  selector: 'app-login-problems',
  templateUrl: './login-problems.component.html',
  styleUrls: ['./login-problems.component.scss'],
})
export class LoginProblemsComponent implements OnInit {

  public problemsForm: FormGroup;
  public isServiceBusy = false;
  @Input('title') title: string;

  constructor(private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private storage: StorageService,
    public gms: GlobalMethodsService,
    private defaultModalComponent: DefaultModalComponent,
    private authService: AuthService,
    public translate: TranslateConfigService,
    public gvs: GlobalVariablesService) { }

  ngOnInit() {
    this.problemsForm = this.formBuilder.group({
      link: new FormControl('', [Validators.required])
    });
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Problemas Login', contentGroup: 'Inicio'});
  }

  dismiss(value, id) {
    this.modalCtrl.dismiss({ result: value }, '', id);
  }

  public async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    if (this.problemsForm.valid) {
      const checkInternet = await this.gms.checkInternet();
      if (checkInternet) {
        this.isServiceBusy = true;
        await this.gms.loading();
        this.problemsForm = this.gms.checkAllowedCharacters(this.problemsForm);
        // await this.storage.setItem(this.gvs.RECOVERY_EMAIL, this.problemsForm.controls.link.value);
        const token: string = await this.authService.getTokenDefaultAuth();
        var succesRequest: PasswordUpdateResponse = await this.authService.sendPasswordResetSMS(this.problemsForm.controls.link.value, token);
        this.isServiceBusy = false;
        // this.defaultModalComponent.setStatusLoading(false);
        this.dismiss(false, "loginProblems");
        this.dismiss(false, "loadSpinner");
        if (succesRequest.error === 0) {
          this.gms.analyticsTrackEvent('login_problems', {eventCategory: 'SICOR/Login', eventAction: 'Accion/Enlace Enviado OK'});
          await this.authService.openSMSMessageSentModalOK();
        }else if(succesRequest.error === 300){
          this.gms.analyticsTrackEvent('login_problems', {eventCategory: 'SICOR/Login', eventAction: 'Error/Enlace Enviado OK'});
          await this.authService.openSMSMessageSentModalKO(succesRequest.message);
        }else{
          this.gms.analyticsTrackEvent('login_problems', {eventCategory: 'SICOR/Login', eventAction: 'Error/Enlace Enviado OK'});
          await this.gms.openFailedProcessModal();
        }
      } else {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      this.validateAllFormFields(this.problemsForm);
    }
  }

  isFieldValid(field: string) {
    return !this.problemsForm.get(field).valid && this.problemsForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (!control.valid){
        this.gms.analyticsTrackEvent('form_error', {eventCategory: 'SICOR/Login', eventAction: 'Error/Form: Enviar Enlace Contraseña', eventLabel:'Campo: ' + field});
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
